module.exports = __webpack_public_path__ + "img/b3c3ef31dd2521de53e453c5f3644ff3.png";